import AccountStatusesAPI from '../../api/accountStatuses';

const DEFAULT_STATUSES = [
  {
    key: 'online',
    base_availability: 'online',
    assignable: true,
    builtin: true,
  },
  { key: 'busy', base_availability: 'busy', assignable: false, builtin: true },
  {
    key: 'offline',
    base_availability: 'offline',
    assignable: false,
    builtin: true,
  },
];
let statusRegistry = DEFAULT_STATUSES;
const syncRegistry = $state => {
  statusRegistry = $state.records;
};
export const isAvailabilityAssignable = key =>
  statusRegistry.find(status => status.key === key)?.assignable === true;

export const state = {
  records: DEFAULT_STATUSES,
  limit: 1,
  canCreate: true,
  isFetching: false,
};

export const getters = {
  getStatuses: $state => $state.records,
  getStatusByKey: $state => key =>
    $state.records.find(status => status.key === key),
  getLimit: $state => $state.limit,
  canCreate: $state => $state.canCreate,
};

export const actions = {
  async get({ commit }) {
    commit('setFetching', true);
    try {
      const { data } = await AccountStatusesAPI.get();
      commit('set', data.payload);
      commit('setLimitMetadata', data.meta);
    } finally {
      commit('setFetching', false);
    }
  },
  async create({ commit }, attributes) {
    const { data } = await AccountStatusesAPI.create({
      account_status: attributes,
    });
    commit('add', data);
  },
  async update({ commit }, { id, ...attributes }) {
    const { data } = await AccountStatusesAPI.update(id, {
      account_status: attributes,
    });
    commit('replace', data);
  },
  async delete({ commit }, id) {
    await AccountStatusesAPI.delete(id);
    commit('remove', id);
  },
};

export const mutations = {
  set: ($state, records) => {
    $state.records = records;
    syncRegistry($state);
  },
  setFetching: ($state, value) => {
    $state.isFetching = value;
  },
  setLimitMetadata: ($state, metadata) => {
    $state.limit = metadata.custom_status_limit;
    $state.canCreate = metadata.can_create;
  },
  add: ($state, record) => {
    $state.records.push(record);
    $state.canCreate =
      $state.records.filter(status => !status.builtin).length < $state.limit;
    syncRegistry($state);
  },
  replace: ($state, record) => {
    const index = $state.records.findIndex(item => item.id === record.id);
    $state.records.splice(index, 1, record);
    syncRegistry($state);
  },
  remove: ($state, id) => {
    $state.records = $state.records.filter(item => item.id !== id);
    $state.canCreate =
      $state.records.filter(status => !status.builtin).length < $state.limit;
    syncRegistry($state);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
